<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="select-bar">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchTechnicalService"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
        <Select
          placeholder="筛选技术人员"
          v-model="techVisible"
          label-in-value
          multiple
          filterable
          @on-query-change="getSearchList"
          @on-change="choseUser"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in techVisibleMember"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          @on-change="selectStatusMethod"
          v-model="selectStatus"
          style="width: 200px; margin-right: 30px"
        >
          <Option
            v-for="item in statusList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <RadioGroup
          class="view-switch"
          v-model="view"
          type="button"
          @on-change="changeView"
        >
          <Radio label="list"><Icon type="md-menu" /></Radio>
          <Radio label="card"><Icon type="ios-grid" /></Radio>
        </RadioGroup>
      </div>
      <div class="button-bar">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadTechService"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button type="primary" @click="openCreateTechServiceDrawer()"
          >新增技术服务</Button
        >
      </div>
    </div>
    <div class="card-wrapper" v-if="view === 'card'" ref="tableWrapper">
      <div
        class="techService-item"
        v-for="(item, parentIndex) in techServicesList"
        :value="item._id"
        :key="item._id"
      >
        <List border class="tech-list">
          <ListItem>
            <div class="title">阶段</div>
            <div>{{ statusToTextMethod(item.status) }}</div>
          </ListItem>
          <ListItem>
            <div class="title">客户</div>
            <div>{{ item.customer.name }}</div>
          </ListItem>
          <ListItem>
            <div class="title">申请人</div>
            <div>{{ item.createdBy.name }}</div>
          </ListItem>
          <ListItem>
            <div class="title">创建日期</div>
            <div>{{ dayjs(item.createdAt) }}</div>
          </ListItem>
          <ListItem>
            <div class="title">技术</div>
            <div @click="showSelectPerson(item)" style="cursor: pointer">
              {{ item.techPerson.map((x) => x.name).join("、") }}
            </div>
          </ListItem>
          <ListItem>
            <div class="title">实验日期</div>
            <div>{{ dayjs(item.scheduleTime, "scheduleTime") }}</div>
          </ListItem>
          <ListItem>
            <div class="title">工单ID</div>
            <div>{{ item._id }}</div>
          </ListItem>
          <ListItem>
            <div class="title">实验结果</div>
            <div>{{ item.result }}</div>
          </ListItem>
          <ListItem v-if="item.status === 'verifying'">
            <div style="height: 112px; line-height: 88px" class="title">
              工单审核
            </div>
            <div style="margin: auto">
              <Button
                type="primary"
                ghost
                size="large"
                long
                @click="showModelMethod(item, 'oAr')"
                >工单+配方通过</Button
              >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 8px;
                  padding: 0;
                "
              >
                <Button
                  type="success"
                  ghost
                  size="small"
                  @click="showModelMethod(item, 'oreder', 'finished')"
                  >工单通过</Button
                >
                <Button
                  type="error"
                  ghost
                  size="small"
                  @click="showModelMethod(item, 'oreder', 'rejected')"
                  >拒绝</Button
                >
              </div>
            </div>
          </ListItem>
          <ListItem v-else>
            <div class="title">工单审核</div>

            <Button
              type="error"
              ghost
              size="small"
              v-if="!['finished', 'canceled', 'rejected'].includes(item.status)"
              >拒绝工单</Button
            >
          </ListItem>
        </List>
        <div class="action">
          <!-- 指派技术员的页面 -->
          <div
            class="techPerson-action-wrap"
            v-if="item.status === 'created' || item.showSelectPerson"
          >
            <h3 class="action-title">指派技术人员</h3>
            <div class="techPerson-action-contetn">
              <div
                class="techPerson"
                :style="{
                  border: techServicesList[parentIndex].showFlag.includes(index)
                    ? '1px solid #0FAEFF'
                    : '',
                }"
                v-for="(person, index) in techPersonList"
                :value="person._id"
                :key="person._id"
                @click="chooseTechPerson(person, parentIndex, index)"
              >
                {{ person.name }}
              </div>
            </div>
            <div class="action-bottom">
              <div style="padding: 12px; width: 25%" class="title">
                确定指派
              </div>
              <Button type="primary" ghost @click="editTechPerson(item)"
                >确定</Button
              >
            </div>
          </div>
          <!-- 配方页面 -->
          <div
            class="action-wrap"
            v-for="recipe in item.recipeSales"
            :value="recipe._id"
            :key="recipe._id"
            v-if="item.status !== 'created'"
          >
            <h3 class="action-title">配方</h3>
            <List class="recipe-wrap">
              <div class="recipe-info">
                <ListItem>
                  <div class="title">配方编号</div>
                  <div>#{{ recipe.NoId }}</div>
                </ListItem>
                <ListItem>
                  <div class="title">创建</div>
                  <div>{{ recipe.NoId }}</div>
                  <div>{{ dayjs(recipe.createdAt) }}</div>
                </ListItem>
                <ListItem
                  class="verify-item"
                  style="
                    justify-content: space-between;
                    border-bottom: 1px solid #e8eaec;
                  "
                >
                  <div class="verify" style="padding: 0">
                    <div class="title" style="padding: 12px">状态</div>
                    <div>{{ statusToTextMethod(recipe.status) }}</div>
                  </div>
                  <div class="verify" style="padding: 0">
                    <div class="title" style="padding: 12px">审核人</div>
                    <div>
                      {{ recipe.verifiedBy ? recipe.verifiedBy.name : "" }}
                    </div>
                  </div>
                </ListItem>
              </div>
              <ListItem>
                <div class="recipe-content">
                  <Row>
                    <Col span="12">材料</Col>
                    <Col span="12" style="text-align: end">比例(%)</Col>
                  </Row>
                  <Row
                    v-for="material in recipe.detail"
                    :value="material._id"
                    :key="material._id"
                    class="material-list"
                  >
                    <Col span="12">{{ material.material.name }}</Col>
                    <Col span="12" style="text-align: end">{{
                      material.ratio * 100
                    }}</Col>
                  </Row>
                </div>
              </ListItem>
              <ListItem class="recipe-bottom">
                <div class="title" style="padding: 12px">配方审核</div>
                <div
                  v-if="
                    recipe.status === 'reviewing' &&
                    !['finished', 'canceled', 'rejected'].includes(item.status)
                  "
                >
                  <Button
                    type="primary"
                    ghost
                    @click="verifiedRecipeMethod(recipe, 'verified', item)"
                    >通过</Button
                  >
                  <Button
                    type="error"
                    ghost
                    style="margin-left: 12px"
                    @click="verifiedRecipeMethod(recipe, 'rejected')"
                    >拒绝</Button
                  >
                </div>
                <div v-else>
                  <div>{{ statusToTextMethod(recipe.status) }}</div>
                </div>
              </ListItem>
            </List>
          </div>
        </div>
      </div>
    </div>
    <div class="list-wrapeer" v-if="view === 'list'" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="techServicesList"
        :height="tableHeight"
      >
        <template slot-scope="{ row }" slot="content">
          <Poptip
            placement="bottom"
            word-wrap
            width="300"
            trigger="hover"
            :content="row.content"
          >
            <p class="content-item">{{ row.content }}</p>
          </Poptip>
        </template>
        <template
          v-if="
            (currentUser.superAdmin ||
              arrayIntersection(['technologyLead'], currentUser.simpleRole)
                .length > 0) &&
            row.status === 'verifying'
          "
          slot-scope="{ row }"
          slot="operate"
        >
          <div class="pass" @click="openVerifiedRecipeModal(row)">验收订单</div>
        </template>
      </Table>
    </div>
    <!-- 验收订单Modal -->
    <Modal v-model="showVerifyOrderModel" title="审核工单" @on-ok="verifyOrder">
      <p>确定要审核该技术服务工单吗？</p>
    </Modal>
    <!-- 验收订单并通过配方 -->
    <Modal
      v-model="showVerifyOandRModel"
      title="验收订单并通过配方"
      @on-ok="verifyOrderAndRecipe"
    >
      <p>确认验收之后所有未验收的订单会自动验收合格并完成订单</p>
    </Modal>
    <CreateTechService ref="CreateTechService" />
    <EditTechService ref="EditTechService" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import CreateTechService from "./CreateTechService";
import EditTechService from "./EditTechService";
import RecipeDrawer from "../SalesPage/RecipeDrawer.vue";
import _ from "lodash";

const statusToText = {
  created: "未接单",
  arranged: "进行中",
  verifying: "待验收",
  finished: "已完成",
  canceled: "已取消",
  reviewing: "待验收",
  verified: "合格",
  rejected: "不合格",
  canceled: "取消",
};
export default {
  name: "TechnicalServicePage",
  components: {
    CreateTechService,
    EditTechService,
    RecipeDrawer,
  },
  data() {
    return {
      page: 0,
      searchText: "",
      view: "list",
      tableLoading: false,
      currentTechService: {},
      filterQuery: { limit: 15 },
      tableHeight: 300,
      techVisible: "",
      techVisibleMember: [],
      selectStatus: "all",
      statusList: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "created",
          label: "未接单",
        },
        {
          value: "arranged",
          label: "进行中",
        },
        {
          value: "verifying",
          label: "待验收",
        },
        {
          value: "finished",
          label: "已完成",
        },
        {
          value: "canceled",
          label: "已取消",
        },
        {
          value: "rejected",
          label: "不合格",
        },
      ],
      techPersonList: [],
      techServicesList: [],
      showVerifyOrderModel: false,
      showVerifyOandRModel: false,
      verifyOrderStatus: null,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "客户名字",
          key: "code",
          minWidth: 140,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditTechService.openDrawer(params.row);
                    },
                  },
                },
                params.row.customer.name
              ),
            ]);
          },
        },
        {
          title: "业务员",
          key: "createdBy",
          align: "center",
          minWidth: 80,
          maxWidth: 120,
          render: (h, params) => {
            return h("div", params.row.createdBy.name);
          },
        },
        {
          title: "实验内容",
          minWidth: 100,
          slot: "content",
        },
        {
          title: "实验时间",
          key: "scheduleTime",
          align: "center",
          minWidth: 100,
          maxWidth: 150,
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.scheduleTime).format("YYYY-MM-DD HH:mm")
            );
          },
        },
        {
          title: "技术人员",
          key: "techPerson",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.techPerson.length > 0
                ? params.row.techPerson
                    .map((x) => {
                      return x.name;
                    })
                    .join("/")
                : ""
            );
          },
        },
        {
          title: "工单状态",
          key: "status",
          align: "center",
          width: 120,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
              },
              [
                h("div", {
                  class: [
                    params.row.status === "finished" ? "finished" : "",
                    params.row.status === "created" ? "created" : "",
                    params.row.status === "canceled" ? "canceled" : "",
                    params.row.status === "verifying" ? "verifying" : "",
                    params.row.status === "arranged" ? "arranged" : "",
                  ],
                  style: {
                    width: "10px",
                    height: "10px",
                    borderRadius: "5px",
                    marginRight: "4px",
                  },
                }),
                h("div", statusToText[params.row.status]),
              ]
            );
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          minWidth: 100,
          maxWidth: 150,
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")
            );
          },
        },
        {
          title: "操作",
          maxWidth: 120,
          align: "center",
          slot: "operate",
        },
      ],
    };
  },
  computed: mapState({
    currentUser: (state) => state.auth.currentUser,
    // techServicesList: (state) => state.technicalService.techServices,
    totalRows: (state) => state.technicalService.totalCounts,
    userList: (state) => state.user.userList,
    user: (state) => state.auth.currentUser,
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getTechService: "technicalService/getTechnicalServiceAction",
      techServiceVerify: "technicalService/techServiceVerifyAction",
      verifyRecipeSales: "recipeSales/verifyRecipeSalesAction",
      getUsersList: "user/getSimpleUserListAction",
      assignTechPerson: "technicalService/assignTechPersonAction",
    }),
    async loadTechService(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 15,
      };
      if (this.selectStatus === "all") {
        delete this.filterQuery.status;
      } else {
        this.filterQuery.status = this.selectStatus;
      }
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getTechService(this.filterQuery);
        data.map((x) => (x.showFlag = [x._id]));
        this.techServicesList = data;
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    // 搜人
    async getSearchList(searchText) {
      if (searchText) {
        try {
          const data = await this.getUsersList({
            userName: searchText,
          });
          this.techVisibleMember = data.userList;
        } catch (error) {
          this.$Message.error(`加载失败: ${error}`);
        }
      }
    },
    // 搜技术服务
    async choseUser(salesVisibleMember) {
      if (salesVisibleMember) {
        this.filterQuery.salesVisibleMember = salesVisibleMember.map(
          (x) => x.value
        );
      } else {
        delete this.filterQuery.salesVisibleMember;
      }
      await this.getTechService(this.filterQuery);
    },
    // 筛选状态
    async selectStatusMethod() {
      this.page = 0;
      await this.loadTechService();
    },
    changeView(e) {
      this.$router.push({
        path: "/home/tech_service",
        query: {
          view: e,
        },
      });
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    },
    dayjs(time) {
      return dayjs(time).format("YYYY-MM-DD");
    },
    searchTechnicalService: _.debounce(function () {
      this.page = 0;
      this.loadTechService();
    }, 1000),
    dayjs(time, type) {
      switch (type) {
        case "scheduleTime":
          return dayjs(time).format("YYYY年MM月DD日 MM:HH");
        default:
          return dayjs(time).format("YYYY年MM月DD日");
      }
    },
    // 获取技术人员的方法
    async getTechPersonMethod() {
      const data = await this.getUsersList({
        simpleRole: "technology",
        limit: 99,
      });
      this.techPersonList = data.userList;
      this.techVisibleMember = data.userList;
    },
    // 添加技术服务
    openCreateTechServiceDrawer() {
      this.$refs.CreateTechService.openDrawer();
    },
    statusToTextMethod(status) {
      return statusToText[status];
    },
    // 选择指派的技术员
    chooseTechPerson(value, parentIndex, index) {
      const data = this.techServicesList[parentIndex];
      if (!data.showFlag.includes(index)) {
        data.showFlag.push(index);
      } else {
        const delIndex = data.showFlag.indexOf(index);
        data.showFlag.splice(delIndex, 1);
      }
      this.$set(this.techServicesList, parentIndex, data);
    },
    // 确认指派的技术员
    async editTechPerson(item) {
      if (item.showFlag.length > 2) {
        const data = [];
        for (let i = 1; i < item.showFlag.length; i++) {
          data.push(this.techPersonList[item.showFlag[i]]);
        }
        const techPerson = data.map((x) => x._id);
        let form = {
          techPerson,
        };
        const result = await this.assignTechPerson({
          id: item._id,
          data: form,
        });
      } else {
        this.$Message.error("请选择技术人员");
      }
    },
    // 已指派技术，但是还想指派
    async showSelectPerson(item) {

      if (item.status === "created" || item.status === "arranged") {
        // 之前操作过一次再操作就会丢失showFlag
        if (!item.showFlag) {
          item.showFlag = [item._id];
        }
        item.showSelectPerson = !item.showSelectPerson;
        const index = this.techServicesList.findIndex(
          (x) => x._id === item._id
        );
        const currentTechPerson = item.techPerson.map((x) => x._id);
        for (let i = 0; i < currentTechPerson.length; i++) {
          item.showFlag.push(
            this.techPersonList.findIndex((x) => x._id === currentTechPerson[i])
          );
        }
        this.$set(this.techServicesList, index, item);
      } else {
        this.$Message.error("当前状态不能更改技术员");
      }
    },
    // 完成订单的方法
    // async compelteTechServiceMethod() {
    //   const data = {};
    //   data.result = this.currentTechService.result;
    //   data.finishedBy = this.currentUser._id;
    //   const id = this.currentTechService._id;
    //   await this.changeTechServiceStatus({ id, data });
    //   this.loadTechService();
    // },

    async verifiedRecipeMethod(recipe, status, item) {
      const data = {};
      data.status = status;
      const result = await this.verifyRecipeSales({ id: recipe._id, data });
      // 获取对应技术服务Index
      const techServiceIndex = this.techServicesList.findIndex(
        (x) => x._id === item._id
      );
      // 获取对配方Index
      const recipeIndex = this.techServicesList[
        techServiceIndex
      ].recipeSales.findIndex((x) => x._id === recipe._id);
      this.$set(
        this.techServicesList[techServiceIndex].recipeSales,
        recipeIndex,
        result
      );
    },
    // 打开弹窗
    showModelMethod(techService, model, status) {
      this.currentTechService = {};
      switch (model) {
        case "oreder":
          this.showVerifyOrderModel = true;
          break;
        case "oAr":
          this.showVerifyOandRModel = true;
          break;
      }
      this.verifyOrderStatus = status;
      this.currentTechService = techService;
    },
    // 验收订单和配方
    async verifyOrderAndRecipe() {},
    // 验收订单
    async verifyOrder() {
      const data = {};
      data.status = this.verifyOrderStatus;
      try {
        await this.techServiceVerify({ id: this.currentTechService._id, data });
        this.$Message.success("审核成功");
      } catch (error) {
        this.$Message.error("审核失败：" + error);
      }
    },
  },
  created() {
    this.getTechPersonMethod();
    this.loadTechService();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    const view = this.$route.query.view;
    if (view) {
      this.view = view;
    }
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .button-bar
    display flex
    align-items center
    justify-content space-between

.card-wrapper
  height 100%
  overflow-y scroll

  .techService-item
    margin-top 18px
    width 70%
    border 1px solid #c9c4c4
    display flex

.techService-item:last-child
  margin-bottom 80px

.tech-list
  min-width 400px

  .ivu-list-item div
    padding 12px

.recipe-info div
  padding 12px

.ivu-list-item
  padding 0

.title
  border-right 1px solid #e8eaec
  min-width 80px
  background-color #d5dee7

.recipe-content
  width 100%
  padding 12px

  .recipe-content div
    padding 0

.recipe-bottom
  .recipe-bottom div
    padding 12px

.material-list:nth-of-type(even)
  background-color #ededed

.verify-item
  .verify
    display flex
    justify-content space-between

  .verify-title
    border-right 1px solid #e8eaec
    background-color #d5dee7

.action
  display flex
  align-items flex-start
  overflow hidden
  overflow-x scroll
  flex 1

.techPerson-action-wrap
  min-width 300px
  max-width 300px
  border 1px solid #e8eaec
  margin 25px 0 0 25px

.action-wrap
  min-width 300px
  border 1px solid #e8eaec
  margin 25px 0 0 25px

.action-title
  background-color #8e8e8f
  color white
  border-bottom 1px solid #e8eaec

.techPerson-action-contetn
  border-bottom 1px solid #e8eaec
  min-height 80px
  display flex
  flex-wrap wrap
  align-content flex-start
  overflow-y scroll
  max-height 196px

  .techPerson
    border 1px solid #C2C2C2
    box-sizing border-box
    font-size 17px
    text-align center
    margin 2px 4px 8px
    padding 2px
    cursor pointer

.action-contetn
  border-bottom 1px solid #e8eaec
  min-height 80px
  display flex
  flex-wrap wrap
  align-content flex-start

.action-bottom
  display flex
  align-items center

.cur
  border 1px solid #0FAEFF
  background-color #fff

.finished
  background-color #2D8CF0

.created
  background-color #949494

.canceled
  background-color #DB1313

.verifying
  background-color #FECF07

.arranged
  background-color #20BE7F
</style>